import { Map } from 'ol';
import TileSource from 'ol/source/Tile';

export abstract class WmsSource {
  protected source?: TileSource;

  abstract initialize(): Promise<void>;

  getSource(): TileSource | undefined {
    return this.source;
  }

  abstract updateAttributions(olMap: Map): Promise<void>;
}
